import type { TicketPriority, TicketStatus } from '../api/types';

export const ticketStatusLabels: Record<TicketStatus, string> = {
  OPEN: 'Offen',
  IN_PROGRESS: 'In Bearbeitung',
  WAITING: 'Wartet auf Rückmeldung',
  DONE: 'Erledigt',
  CANCELED: 'Verworfen',
};

export const ticketPriorityLabels: Record<TicketPriority, string> = {
  LOW: 'Niedrig',
  NORMAL: 'Normal',
  HIGH: 'Hoch',
  URGENT: 'Dringend',
};

// Teams, an die Rückfragen gehen können (Projektrollen).
export const teamLabels: Record<string, string> = {
  SUPPORT: 'Support',
  FIELD_SALES: 'Außendienst',
  TELESALES: 'Telefonakquise',
  SUPERVISOR: 'Supervisor',
  PROJECT_LEAD: 'Projektleitung',
};

export const ticketEventLabels: Record<string, string> = {
  CREATED: 'erstellt',
  STATUS_CHANGED: 'Status geändert',
  ASSIGNED: 'neu zugewiesen',
  PRIORITY_CHANGED: 'Priorität geändert',
  CATEGORY_CHANGED: 'Kategorie geändert',
  COMMENTED: 'kommentiert',
  COMMENT_EDITED: 'Kommentar bearbeitet',
  DUE_CHANGED: 'Fälligkeit geändert',
  COMPLETED: 'erledigt',
  REOPENED: 'erneut geöffnet',
  UPDATED: 'bearbeitet',
  EMAIL_RECEIVED: 'E-Mail eingegangen',
};

export const openStatuses: TicketStatus[] = ['OPEN', 'IN_PROGRESS', 'WAITING'];

// Innendienst: Rollen, die Rückfragen übernehmen können (Projekteinstellung „Rückfragen gehen an“).
export const staffRoles = ['SUPPORT', 'TELESALES', 'SUPERVISOR', 'PROJECT_LEAD'];

// needsResult: Rückfragen einer Person werden nur mit Ergebnis erledigt (OFFENE_FRAGEN B-23) – nicht Terminrückgaben.
export const needsResult = (t: { kind: string; created_by_user_id?: string | null; category: string }) =>
  t.kind === 'REQUEST' && !!t.created_by_user_id && t.category !== 'APPOINTMENT_HANDBACK';
export const isOpen = (s: TicketStatus) => openStatuses.includes(s);

export function assigneeLabel(t: { assigned_to_name?: string | null; assigned_role?: string | null }): string {
  if (t.assigned_to_name) return t.assigned_to_name;
  if (t.assigned_role) return `Team ${teamLabels[t.assigned_role] ?? t.assigned_role}`;
  return 'Nicht zugewiesen';
}

export function priorityClass(p: TicketPriority): string {
  if (p === 'URGENT') return 'badge badge-error';
  if (p === 'HIGH') return 'badge badge-warn';
  return 'badge badge-muted';
}

// Werte des datetime-local-Felds (Europe/Berlin wird vom Browser angenommen) → ISO.
export function localInputToIso(v: string): string | undefined {
  if (!v) return undefined;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
}
